export enum AssetsPlatformAccessOperation {
    read = "bc266476-ba26-4666-bb6b-d25cbf7b41b8",
}
